
const { location: { href } } = require('window');

const url = require('url');

const _ = require('lodash');


module.exports = new class ClientSourceHelper {
	_getXClientSourceHeaderValue () {
		const { query } = url.parse(href, true);
		return _.mapValues(query, v => _.first([].concat(v)));
	}

	getAdditionalRequestHeaders () {
		const header = this._getXClientSourceHeaderValue();
		return {
			'x-client-source': encodeURIComponent(JSON.stringify(header)),
		};
	}
};
